import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { SocialDistributionState } from '../types'
import { socials } from '@/config/socialDistribution'
import { Platform } from '@/types/platform'
import { SocialGroup } from '@/types/socialDistribution'

const hiddenChannels: Record<string, Record<string, string[]>> = {
  [Platform.cosmo]: {
    viber: ['voice', 'home_secrets_of_beauty'],
  },
  [Platform.goodhouse]: {
    viber: ['life_over_50_plus', 'cats', 'royal_news'],
  },
  [Platform.mhealth]: {
    viber: ['mentoday'],
  },
  [Platform.popmech]: {
    viber: ['techinsider'],
  },
  [Platform.girlspower]: {
    viber: ['idol'],
  },
}

const availableSocials: Getter<SocialDistributionState, RootState> = (
  state,
  getters,
  rootState
) => {
  const disabledChannels = hiddenChannels[rootState.platform] || {}

  return Object.entries(state.groups).reduce<
    { text: string; value: string; channels: SocialGroup[] }[]
  >((acc, [socialCode, groups]) => {
    if (
      socialCode === 'twitter' ||
      (socialCode === 'viber' && rootState.platform === Platform.cosmo)
    ) {
      return acc
    }

    const socialDisabledChannels = disabledChannels[socialCode] || []

    const channels = groups.filter(
      ({ code }) => !socialDisabledChannels.includes(code)
    )

    if (!channels.length) {
      return acc
    }

    acc.push({
      text: socials[socialCode]?.title || socialCode,
      value: socialCode,
      channels,
    })

    return acc
  }, [])
}

export default availableSocials
